import { Trans } from "@lingui/react";
import type { ReactNode } from "react";
import "./keyInfo.css";

type Props = {
  children?: ReactNode;
};

export const KeyInfo = ({ children }: Props) => {
  return (
    <section className="key-info">
      <h2 className="t3 mb-0">
        <Trans
          id="itemPageLayout.keyInfo.title"
          message="Specifications"
          comment="Title for the specifications/key info section on the ad page"
        />
      </h2>
      <dl className="emptycheck columns-2 md:columns-3 break-words mb-0 mt-16 relative">{children}</dl>
    </section>
  );
};
